<template>
  <div class="top-box">
    <div class="top-box-int">
      <div class="top-left">
        <img src="../../static/images/logo.png"/>
      </div>
      <div class="top-right-box">
        <div v-for="(item,index) in menuList" :class="['menu-lable',((item.children.length > 0 && item.value.indexOf(routePath) > -1)||(item.children.length < 1 && item.value == routePath))?'menu-lable-check':''] ">
          <div class="menu-lable-item" @click="skipPage(item,1)">
          {{item.lable}}
          </div>
          <div class="top-right-hover">
            <div class="hover-item" v-for="(item2,index2) in item.children" @click="skipPage(item2,2)">
              {{item2.lable}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      routePath:'/',
      menuList:[{
        lable:'首页',
        value:'/',
        children:[]
      },{
        lable:'关于盛弘',
        value:['/aboutUs'],
        children:[{
          lable:'公司简介',
          value:'/aboutUs',
        }]
      },{
        lable:'服务项目',
        value:['/occupationalHygiene','/safetyAssessment','/environmentDetection'],
        children:[{
          lable:'职业卫生检测与评价',
          value:'/occupationalHygiene',
        },{
          lable:'安全技术服务',
          value:'/safetyAssessment',
        },{
          lable:'环保技术服务',
          value:'/environmentDetection',
        }]
      },{
        lable:'信息公开',
        value:['/reports','/reportInfo','/newsList','/newsInfo','publicNotice'],
        children:[{
          lable:'职业卫生报告',
          value:'/reports',
        },{
          lable:'信息公示',
          value:'/publicNotice',
        },{
          lable:'新闻资讯',
          value:'/newsList',
        }]
      },{
        lable:'联系我们',
        value:'/contactUs',
        children:[]
      }]
    }
  },
  created() {
    this.getRoute()
  },
  methods:{
    getRoute(){
      this.routePath = this.$route.path;
    },
    skipPage(item,type){
      if(this.routePath == item.value){
        return false;
      }
      if(type==1){
        if(item.children.length < 1){
          this.$router.push(item.value)
        }else{
          this.$router.push(item.children[0].value)
        }
      }else{
        this.$router.push(item.value)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .top-box{
    height: 98px;
    width: 100%;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    .top-box-int{
      width: 1200px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .top-left{
        width: 366px;
        img{
          width: 100%;
        }
      }
      .top-right-box{
        display: flex;
        align-items: center;
        .menu-lable{
          // padding:0 25px;
          width: 120px;
          margin:0 10px;
          height: 100px;
          cursor:pointer;
          position: relative;
          .menu-lable-item{
            display: flex;
            align-items: center;
            justify-content: center;
             height: 100px;
          }
        }
        .menu-lable-check{
          height: 95px;
          color: #00a73c;
          border-bottom: 5px solid #00a73c;
        }
        .menu-lable:hover{
          height: 95px;
          color: #00a73c;
          border-bottom: 5px solid #00a73c;
        }
         .menu-lable:hover .top-right-hover{
           display: block;
         }
         .top-right-hover:hover{
            display: block;
         }
        .top-right-hover{
          display: none;
          background: #FFFFFF;
          // padding:0 25px;
          width: 130px;
          position: absolute;
          top: 100px;
          z-index: 100;
          .hover-item{
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #f0f0f0;
            color: #AAAAAA;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .hover-item:hover{
            color: #00a73c;
          }
          .hover-item:last-child{
            border-bottom:none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue